var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["anno", this.maskShow ? "" : "row"] }, [
    _c("div", {
      directives: [
        {
          name: "wechat-title",
          rawName: "v-wechat-title",
          value: _vm.$route.meta.title,
          expression: "$route.meta.title"
        }
      ]
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container", class: _vm.langType }, [
      _c("div", { staticClass: "topTitle" }, [
        _c("img", {
          staticClass: "icon1",
          attrs: { src: require("../assets/icon1.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "inviteView" }, [
          _c("div", { staticClass: "topView" }, [
            _c("img", {
              staticClass: "userImg",
              attrs: { src: _vm.headImg },
              on: {
                click: function($event) {
                  return _vm.toRoom("224803")
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "inviteInfo" }, [
              _vm.langType === "ar"
                ? _c("span", [_vm._v("يدعوك")])
                : _c("span", [_vm._v("Invite")]),
              _vm._v(" "),
              _c("span", { staticClass: "nickNameView" }, [
                _vm._v(_vm._s(this.nickName))
              ]),
              _vm._v(" "),
              _vm.langType === "ar"
                ? _c("span", [
                    _vm._v("للدخول إلى الغرفة للدردشة والاستمتاع سوياً")
                  ])
                : _c("span", [
                    _vm._v("To enter the room chat and have fun together")
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c("img", {
          staticClass: "emogi_01",
          attrs: {
            src:
              _vm.mySwiper.realIndex == 1
                ? _vm.emoji2
                : _vm.mySwiper.realIndex == 2
                ? _vm.emoji3
                : _vm.mySwiper.realIndex == 3
                ? _vm.emoji4
                : _vm.emoji1
          }
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mySwiper.realIndex == 0,
              expression: "mySwiper.realIndex == 0"
            }
          ],
          staticClass: "emogi_02",
          attrs: { src: require("../assets/share_emoji_04.png") }
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mySwiper.realIndex == 3,
              expression: "mySwiper.realIndex == 3"
            }
          ],
          staticClass: "emogi_03",
          attrs: { src: require("../assets/share_emoji_05.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "contentView" }, [
          _c("div", { ref: "Myswper", staticClass: "swiper-container" }, [
            _vm._m(1)
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lineSwiper" }, [
          _c("p", {
            class: ["p1", _vm.mySwiper.realIndex == 0 ? "pSelect" : ""]
          }),
          _vm._v(" "),
          _c("p", {
            class: ["p2", _vm.mySwiper.realIndex == 1 ? "pSelect" : ""]
          }),
          _vm._v(" "),
          _c("p", {
            class: ["p2", _vm.mySwiper.realIndex == 2 ? "pSelect" : ""]
          }),
          _vm._v(" "),
          _c("p", {
            class: ["p3", _vm.mySwiper.realIndex == 3 ? "pSelect" : ""]
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.tips != ""
      ? _c("div", { staticClass: "tips", class: { on: _vm.tips != "" } }, [
          _c("p", [_vm._v(_vm._s(_vm.tips))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "bottomView",
        class: ["footerView", _vm.toBottom == true ? "footerView1" : ""]
      },
      [
        _vm.langType === "ar"
          ? _c("img", {
              staticClass: "clickBtn",
              attrs: {
                id: "downloadButton",
                src: require("../assets/clickBtn-ar.png")
              }
            })
          : _c("img", {
              staticClass: "clickBtn",
              attrs: {
                id: "downloadButton",
                src: require("../assets/clickBtn-en.png")
              }
            })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottomView" }, [
      _c("div", [
        _c("p", [_vm._v("456893")]),
        _vm._v(" "),
        _c("p", [_vm._v("Invite code")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-wrapper" }, [
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_1" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_2" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_4" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6028a368", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6028a368","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips.vue
// module id = null
// module chunks = 